/**
 * Handle mailbox / warming checkout responses (increment vs new Checkout).
 */
export async function applySeatCheckoutResponse(data, { toast, onUpdated, redirect }) {
  if (!data) return false;
  if (data.status === 'quantity_updated') {
    if (toast) {
      toast({
        title: 'Subscription updated',
        description: data.added
          ? `Added ${data.added} seat(s). Total quantity: ${data.quantity}.`
          : 'Your seat count was updated.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    }
    if (onUpdated) {
      await onUpdated();
    }
    return true;
  }
  const url = data.url;
  if (url && redirect) {
    window.location.href = url;
    return true;
  }
  return false;
}
